/**
 * The page owns its data across desktop/mobile presentation changes.
 */
import { lazyLoad } from 'utils/loadable';

export const ReviewApprovalDashboard = lazyLoad(
  () => import('./index'),
  module => module.ReviewApprovalDashboard
);
